<template>
  <div>
    <v-layout row>
      <v-flex xs12>
        <v-form ref="form" novalidate v-model="valid" @submit="submit">
          <fieldset>
            <legend>Song Information</legend>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field
                    data-lpignore="true"
                    label="Song Title"
                    v-model="song.song"
                    :rules="validate.songTitleRules"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3><!-- @todo: use combobox (https://vuetifyjs.com/en/components/combobox) to allow new album creation from here -->
                  <v-autocomplete
                    append-icon="fa fa-sort-down"
                    data-lpignore="true"
                    :items="albums"
                    v-model="song.albumid"
                    item-text="Album"
                    item-value="ID"
                    label="Album"
                    :rules="validate.albumRules"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 sm6 md3>
                  <v-menu
                    ref="menu"
                    lazy
                    :close-on-content-click="false"
                    v-model="menu"
                    transition="scale-transition"
                    offset-y
                    full-width
                    :nudge-right="40"
                    min-width="290px"
                    :return-value.sync="song.duedate"
                  >
                    <v-text-field
                      clearable
                      slot="activator"
                      label="Due Date"
                      v-model="song.duedate"
                      prepend-icon="fa-calendar-alt"
                      readonly
                    ></v-text-field>
                    <v-date-picker 
                      v-model="song.duedate"
                      @input="$refs.menu.save(song.duedate)"></v-date-picker>

                  </v-menu>
                </v-flex>
                <v-flex xs12>
                  <v-card color="blue-grey lighten-3" class="white--text">
                    <v-card-title primary-title>
                      <div style="width:100%;">
                        <h3 class="headline mb-0">Motivation</h3>
                        <p>
                          <v-textarea
                            autofocus
                            auto-grow
                            counter="1000"
                            full-width
                            id="motivation"
                            maxlength="1000"
                            name="motivation"
                            placeholder="Add your motivation for writing this song."
                            v-model="song.motivation"
                            :rules="validate.motivationRules"
                          ></v-textarea>
                        </p>
                      </div>
                    </v-card-title>
                  </v-card>
                </v-flex>
                <v-flex xs12>
                  <p class="text-xs-right">
                    <v-btn color="primary" type="submit">Create</v-btn>    
                  </p>
                </v-flex>
              </v-layout>
            </v-container>
          </fieldset>
        </v-form>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { Validate } from '../../Shared'
import API from '@/api'

export default {
  name: 'createsong',

  components: {
    Validate
  },

  data: () => ({
    albums: [],
    song: {
      albumid: '',
      duedate: '',
      motivation: '',
      song: ''
    },
    menu: false,
    valid: false,
    validate: Validate
  }),

  head: {
    title: {
      inner: 'Create Your Song'
    }
  },

  created () {
    API.get('song/create', {
      rollbarMessage: 'Error getting albums',
      success: data => {
        if (data !== undefined) {
          if (data.Albums.length > 0) {
            this.albums = data.Albums
          }
        }
      }
    }, this)
  },

  methods: {
    submit (e) {
      e.preventDefault()
      API.post('song/create/' + this.song.albumid, {
        data: { song: this.song },
        errorMessage: 'There was an error creating your song.',
        rollbarMessage: 'Error creating song',
        validateElem: this.$refs.form,
        success: data => {
          this.$router.push({
            name: 'EditSong',
            params: { id: data.ID }
          })
        }
      }, this)
    }
  }
}
</script>